import api from './api';

type Props = {
  lang: 'ptbr' | 'en' | 'es';
};

export async function downloadUserGuides(params: Props): Promise<any> {
  const response = await api.get('/user-guide', {
    params,
  });

  return response.data;
}
